import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Academics from "./pages/Academics";
import SchoolFormat from "./pages/SchoolFormat";
import Admissions from "./pages/Admissions";
import SchoolLife from "./pages/SchoolLife";
import Inquire from "./pages/Inquire";
import Electives from "./pages/Electives";
import LearningAndPlacement from "./pages/LearningAndPlacement";
import WhatIsEducationFor from "./pages/WhatIsEducationFor";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/school-format" element={<SchoolFormat />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/school-life" element={<SchoolLife />} />
          <Route path="/electives" element={<Electives />} />
          <Route path="/learning-placement" element={<LearningAndPlacement />} />
          <Route path="/blog/what-is-education-for" element={<WhatIsEducationFor />} />
          <Route path="/inquire" element={<Inquire />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
